import React from "react";
import { useAppSelector } from "../../../redux/store";
import { useTranslation } from "react-i18next";

const Details = () => {
  const { t } = useTranslation();
  const booking = useAppSelector((state) => state.booking);
  const isAgency = booking.isAgencyBooking;
  const payments = booking.payment;

  return (
    <div className="col-12">
      {!isAgency && (
        <table className="table">
          <tr>
            <th></th>
            <th>{t("bookingDetails.payments.amount")}</th>
            <th>{t("bookingDetails.payments.maturity")}</th>
          </tr>

          <tbody>
            {payments != null && payments.downPaymentAmount.length > 0 ? (
              <tr>
                <th>{t("bookingDetails.payments.downPayment")}</th>
                <td>
                  <span className="price_num">
                    {payments.downPaymentAmount}
                  </span>
                </td>
                <td>{payments.downPaymentDueDate}</td>
                <td>{payments.downPaymentStatus}</td>
              </tr>
            ) : null}

            {payments != null && payments.finalPaymentAmount.length > 0 ? (
              <tr>
                <th>{t("bookingDetails.payments.finalPayment")}</th>
                <td>
                  <span className="price_num">
                    {payments.finalPaymentAmount}
                  </span>
                </td>
                <td>{payments.finalPaymentDueDate}</td>
                <td>{payments.finalPaymentStatus}</td>
              </tr>
            ) : null}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Details;
